import { GuidanceStepRoute } from '/@/modules/guidancestep/routes/guidancestep.routes';
import { GuidanceStepRouteConfig } from '/@/modules/guidancestep/routes/GuidanceStepRouteConfig';

export const router = [
  GuidanceStepRouteConfig.factory({
    path: `/${GuidanceStepRoute.NEXTSTEPS.path}`,
    name: GuidanceStepRoute.NEXTSTEPS.name,
    component: () => import('/@/modules/guidancestep/pages/GuidanceStepPage.vue'),
    meta: { authOnly: true }
  }).build()
];
